import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Search, ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  label: 'Platform',
  to: '/platform'
}, {
  label: 'BAS',
  to: '/breach-and-attack-simulation'
}, {
  label: 'Research',
  to: '/research'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  return <header className={`fixed top-[52px] left-0 right-0 z-50 transition-all duration-300 border-b border-transparent ${scrolled ? 'bg-white/90 backdrop-blur-md py-4 shadow-sm' : 'bg-white py-4'}`} data-id="element-372">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-373">
        {/* Left Nav */}
        <nav className="hidden lg:flex items-center gap-12 flex-1" data-id="element-374">
          {navLinks.map(link => {
          const isActive = location.pathname === link.to || link.to !== '/' && location.pathname.startsWith(link.to);
          return <Link key={link.to} to={link.to} className={`font-mono text-[14px] leading-[16px] font-medium uppercase tracking-[2px] text-black hover:text-picus-accent transition-colors duration-200 ${isActive ? 'text-picus-accent' : ''}`} data-id="element-375">
                {link.label}
              </Link>;
        })}
        </nav>

        {/* Center Logo */}
        <Link to="/" className="flex-shrink-0 z-10 flex-1 flex justify-center" data-id="element-376">
          <span className="font-sans text-[20px] font-medium tracking-[4px] uppercase text-black" data-id="element-377">
            Picus
          </span>
        </Link>

        {/* Right CTAs */}
        <div className="hidden lg:flex items-center justify-end gap-6 flex-1" data-id="element-378">
          <a href="https://app.picussecurity.com" target="_blank" rel="noopener noreferrer" className="font-mono text-[14px] leading-[16px] font-medium uppercase tracking-[2px] text-black hover:text-picus-accent transition-colors" data-id="element-379">
            Log In
          </a>
          <Link to="/contact" className="inline-flex items-center justify-center px-4 py-2 border border-black text-black font-mono text-[14px] leading-[16px] font-medium uppercase tracking-[2px] hover:bg-black hover:text-white transition-colors" data-id="element-380">
            Try or Buy
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button className="lg:hidden text-black p-2 z-10 relative" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-381">
          {mobileMenuOpen ? <X data-id="element-382" /> : <Menu data-id="element-383" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-384">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="lg:hidden absolute top-full left-0 right-0 bg-picus-surface border-b border-picus-border shadow-2xl" data-id="element-385">
            <div className="px-6 py-6 flex flex-col gap-6" data-id="element-386">
              {navLinks.map(link => <Link key={link.to} to={link.to} className="font-mono text-sm uppercase tracking-widest text-picus-muted hover:text-white transition-colors" data-id="element-387">
                  {link.label}
                </Link>)}
              <div className="h-px bg-picus-border w-full my-2" data-id="element-388" />
              <Link to="/contact" className="font-mono text-sm uppercase tracking-widest text-white flex items-center gap-2" data-id="element-389">
                Try or Buy <ArrowRight className="w-4 h-4" data-id="element-390" />
              </Link>
              <a href="https://app.picussecurity.com" target="_blank" rel="noopener noreferrer" className="font-mono text-sm uppercase tracking-widest text-picus-muted hover:text-white transition-colors" data-id="element-391">
                Log In
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}